import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getLanguages } from "shared/constants/languages";

export const LANGUAGES_QUERY_KEY = "languages";
export const useLanguagesQuery = () => {
  return useQuery({
    queryKey: [LANGUAGES_QUERY_KEY],
    queryFn: async () => {
      return getLanguages();
    },
  });
};

export const invalidateLanguages = () => {
  return queryClient.invalidateQueries({
    queryKey: [LANGUAGES_QUERY_KEY],
  });
};
